<template>
  <div class="row mt-3">
    <div class="col-12 mb-4">
      <nav class="portal_menu">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <router-link
              :to="{ name: 'billingLatestBills'}"
              :class="{ active: $route.name === 'billingLatestBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{ $t('billing.latest_bills_list') }}
          </router-link>
          <router-link
              :to="{ name: 'billingArchivedBills'}"
              :class="{ active: $route.name === 'billingArchivedBills'}"
              class="nav-item nav-link"
              role="tab"
              aria-controls="nav-profile"
              aria-selected="false">
            {{ $t('billing.archived_bills_list') }}
          </router-link>
        </div>
      </nav>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>